import { useEffect, useRef, useState } from "react";

export const TYPEWRITER_STEP_MS = 24;
export const TYPEWRITER_CHARS_PER_STEP = 2;

export const useTypewriter = (text: string): string => {
  const animates = useRef(text.length === 0);
  const [count, setCount] = useState(0);
  const targetRef = useRef(text.length);
  const previousRef = useRef(text);

  targetRef.current = text.length;
  const running = animates.current;
  const caught = count >= text.length;

  useEffect(() => {
    if (!text.startsWith(previousRef.current)) setCount(0);
    previousRef.current = text;
  }, [text]);

  useEffect(() => {
    if (!running || caught) return;

    const id = setInterval(
      () =>
        setCount((n) =>
          Math.min(targetRef.current, n + TYPEWRITER_CHARS_PER_STEP),
        ),
      TYPEWRITER_STEP_MS,
    );
    return () => clearInterval(id);
  }, [running, caught]);

  if (!running) return text;
  return text.slice(0, Math.min(count, text.length));
};
